import request from '@/plugins/axios';

//GET
// /_product_/loginSubscribe/getInfo
// 登录用户根据订阅管理员编号查看订阅号信息
export function getSubsInfo() {
    return request[0]({
        url: '/_product_/loginSubscribe/getInfo',
        method: 'get',
    })
}

//POST
// /_product_/subscribe/createSubscribe
// 申请订阅号
export function createSubscribe(data) {
    return request[0]({
        url: '/_product_/subscribe/createSubscribe',
        method: 'post',
        data
    })
}

//POST
// /_product_/subscribe/updateSubscribe
// 编辑订阅号信息
export function updateSubscribe(data) {
    return request[0]({
        url: '/_product_/subscribe/updateSubscribe',
        method: 'post',
        data
    })
}

//GET
// /_product_/subscribeCensus/getInfo
// 获取订阅号数量统计相关
export function subscribeCensus(params) {
    return request[0]({
        url: '/_product_/subscribeCensus/getInfo',
        method: 'get',
        params
    })
}

// GET
// /_product_/subscribeType/list
// 获取订阅号分类列表
export function subscribeTypeList(params) {
    return request[0]({
        url: '/_product_/subscribeType/list',
        method: 'get',
        params
    })
}


// /_product_/subscribeUserAccess/createSubscribeUserAccess
// 用户订阅订阅号
export function createSubscribeUserAccess(data) {
    return request[0]({
        url: '/_product_/subscribeUserAccess/createSubscribeUserAccess',
        method: 'post',
        data
    })
}

//POST
// /_product_/subscribeUserAccess/deleteSubscribeUserAccess
// 用户取消订阅订阅号
export function deleteSubscribeUserAccess(data) {
    return request[0]({
        url: '/_product_/subscribeUserAccess/deleteSubscribeUserAccess',
        method: 'post',
        data
    })
}

//GET
// /_product_/subscribeUserAccess/list
// 我的订阅号
export function getSubsList(params) {
    return request[0]({
        url: '/_product_/subscribeUserAccess/list',
        method: 'get',
        params
    })
}

//POST
// /sso/sendSms
// 发送验证码
export function sendSms(data) {
    return request[0]({
        url: '/sso/sendSms',
        method: 'post',
        data
    })
}
